{
  "en": {
    "unit": {
      "actions": {
        "bulk": {
          "activate": "Activate units",
          "deactivate": "Deactivate units",
          "give_access": "Give access to customers",
          "revoke_access": "Revoke access customers"
        },
        "revokeAccess": "Revoke access",
        "select": "Select type",
        "selectOutdoorCategory": "Select outdoor space",
        "selectUnit": "Select Unit",
        "setCustomer": "Assign a customer to",
        "setVisible": "Give access",
        "submit": "Submit",
        "update_pricing": "Update pricing"
      },
      "attributes": {
        "address_city": "City",
        "address_country": "Country",
        "address_number": "Number",
        "address_street": "Street",
        "address_zip": "Post Code",
        "amount": "Amount",
        "bathrooms": "Number of bathrooms",
        "bedrooms": "Number of bedrooms",
        "category": "Type",
        "category_outdoor": "Outdoor space",
        "customer": "Customer",
        "deed_signed_at": "Date of exchange of contracts",
        "description": "Description",
        "electricity": "Electricity",
        "floor": "Storey",
        "house_subcategory": "Housing type",
        "internal_note": "Unit internal note",
        "meter_number": "Meter number",
        "meter_number_electricity": "Meter number electricity",
        "meter_number_gas": "Meter number gas",
        "meter_number_warmth": "Meter number warmth",
        "meter_number_water": "Meter number water",
        "meter_numbers": "Meter numbers",
        "name": "Name",
        "orientation": "Orientation",
        "price_value": "Total sales value",
        "price_value_construction": "Construction value",
        "price_value_construction_existing": "Costs of existing construction",
        "price_value_fees": "Architect/Engineering fees",
        "price_value_land": "Land value",
        "quotity": "Transfer amount portion",
        "sales_employee": "Sales rep",
        "status": "Status",
        "surface_garden": "Surface garden",
        "surface_terrace": "Surface terrace",
        "surface_total": "Total surface",
        "tax_percentage": "Tax %",
        "toilets": "Number of toilets",
        "total": "Total",
        "vat_percentage": "VAT %"
      },
      "house_subtype": {
        "detached": "Detached house",
        "rowhouse": "Terraced house",
        "semidetached": "Semi-detached house"
      },
      "labels": {
        "activate": "Activate",
        "address": "Address",
        "areYouSureDeactivate": "Are you sure you want to deactivate {unit_name}?",
        "bathrooms": "bathrooms | bathrooms",
        "bedrooms": "bedroom | bedrooms",
        "cannot_activate_all_units": "You don't have enough remaining units to activate all the seleted units",
        "deactivate": "Deactivate",
        "deactivateMessage": "The customer can still communicate with you, and will still have access to all their information. All other actions such as creating decisions, uploading documents, sending out surveys, etc for {unit_name} will nevertheless not be possible.",
        "deactivated": "Deactivated",
        "deedSignedOn": "Contracts signed on {date}",
        "deedWillBeSignedOn": "Contracts will be signed on {date}",
        "detailed_price": "Detailed",
        "details": "Details",
        "email_address_secondary_delivery_content": "does receive notification emails as former secondary contact",
        "email_address_secondary_delivery_tip": "This customer was originally added as a secondary contact to the other customer, before support for multiple customers per unit was introduced: this customer will keep receiving the same notification emails as the other customer, however only the other customer has unit/login access.",
        "existingVatValues": "Some VAT values are different than 0",
        "export": "Export",
        "export_preparing": "Collecting unit's data may take a few seconds.",
        "facing": "Facing {direction}",
        "fromATotal": "Project total: {total}",
        "general": "General",
        "howDoesCustomerSeeThis": "How does the customer see his unit?",
        "integrationNoCustomerAssigned": "No customer(s) assigned, please assign customer(s) in {integration_name}.",
        "internal": "Internal",
        "internalDisclaimer": "This information is only visible for your team",
        "invitationAddEmailAddress": "In order to give {customer} access to the unit, please first fill in the email address on the customer's contact page.",
        "invitationAddEmailAddress_SUP": "In order to give {customer} access to the project, please first fill in the email address on the customer's contact page.",
        "invitationSentTo": "{customer} will be receiving his invitation soon at {email}",
        "maintainerNoCustomerAssigned": "No customer assigned, only team members with the role 'Owner' can assign a customer to a unit.",
        "more": "more",
        "onFloor": "On storey",
        "or_create_new": "Create new",
        "other_units": "Has other units",
        "price_view": "Price view",
        "sales_value": "All prices are in {currency}",
        "scopes": {
          "invisible": "No unit access",
          "invisible_SUP": "No project access",
          "visible": "Has access",
          "visible_SUP": "Has access"
        },
        "search_unit": "Search unit or customer...",
        "selectUnit": "Select a Unit",
        "select_contact_required": "Please select a contact first",
        "select_existing_contact": "Existing",
        "set_unit_price": "Set unit price",
        "showUnit": "Show Unit",
        "simple_price": "Simple",
        "toggleDetailedPrice": "Switch price view",
        "unassigned": "No customer assigned",
        "unit": "No unit | One unit | {count} Units",
        "unitLabel": "Unit",
        "utilities": "Utilities",
        "visibleCustomer": "This information is visible for customers"
      },
      "outdoor_category": {
        "balcony": "Balcony",
        "garden": "Garden",
        "null": "None",
        "terrace": "Terrace",
        "terrace_garden": "Terrace + Garden"
      },
      "status": {
        "available": "Available",
        "unavailable": "Unavailable"
      },
      "toasts": {
        "activateSuccess": "{unit_name} has been successfully activated",
        "create_fixed": "Unit created",
        "create_rundle": "New active unit created. 1 active unit left. | New active unit created. {count} active units left.",
        "deactivateSuccess": "{unit_name} has been successfully deactivated",
        "delete": "Unit deleted",
        "update": "Unit updated"
      },
      "type": {
        "alf": "Assisted-living facility",
        "apartment": "Apartment",
        "cellar": "Cellar",
        "commercial": "Commercial",
        "duplex": "Duplex",
        "house": "House",
        "loft": "Loft",
        "office": "Office",
        "penthouse": "Penthouse",
        "sme": "SME Unit",
        "studio": "Studio"
      },
      "validation": {
        "needName": "Title is required",
        "needNumber": "Must be a number (e.g. 85)",
        "pricesNotUpdatable": "Some or all prices have been used for installments, and can't therefore be edited. Remove the associated installments in order to edit the prices again",
        "totalSalesValueNotEqualToParts": "Looks like the total sales value is not equal to the sum of its parts"
      }
    }
  }
}
